import React, { useState, useEffect, forwardRef } from 'react';
import { useIsMobileLayout } from '@/hooks';
import { Flex, Text, CustomButton, CheckBox } from '@/components';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { updateInvitationFlag } from '@/redux/slices/document'; // Asegúrate de importar la acción
import { Tooltip } from 'react-tooltip';
import { QuestIcon } from '@/assets/icons';
import { getStoredInvitationConfig } from '@/helpers';


// ——— Mobile hook ———
const MOBILE_BREAKPOINT = 768;
function useIsMobile () {
  const isMobile = useIsMobileLayout();
  return isMobile;
}

const AllowDownload = forwardRef((props, ref) => {
  const isMobile = useIsMobile();
  const buttonPadding = isMobile ? '4px 10px' : '10px 5px';
  const textSize     = isMobile ? '14px' : 'inherit';
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { primaryColor } = useSelector(({ theme }) => theme);
  const documentId = useSelector(state => state.document.documentInfo.id);
  const config = useSelector(state => state.document.invitationConfig[documentId] || {});
  const isAllowed = config.allowDownload || false;

  useEffect(() => {
    if (ref && ref.current) {
      setTimeout(() => {
        ref.current.id = 'allow-download-button';
      }, 500); // Pequeña espera para evitar que el ref sea `null`
    }
  }, [ref]);

  const toggleAllowDownload = () => {
    const newValue = !isAllowed;
    dispatch(updateInvitationFlag({
      documentId,
      flag: 'allowDownload',
      value: newValue
    }));
    // Persist in localStorage
    const storedConfig = getStoredInvitationConfig(documentId);
    localStorage.setItem(`invitationConfig_${documentId}`, JSON.stringify({ ...storedConfig, allowDownload: newValue }));
  };

  return (
    <Flex
      direction="column"
      gap="10px"
      mb={props.minimal ? "5px" : "1em"}
      align={props.minimal ? "center" : "stretch"}
      w={props.minimal ? "fit-content" : "100%"}
    >
      {props.minimal ? (
        <Flex
          align="center"
          justify="center"
          gap="10px"
          style={{ position: 'relative', cursor: 'pointer' }}
          onClick={toggleAllowDownload}
        >
          <CheckBox
            color="#000000"
            active={isAllowed}
            action={toggleAllowDownload}
          />
          <Flex align="center" gap="5px" w="fit-content">
            <Text clave="allow_download" size="13px" color="#6B7280" />
            <div data-tooltip-id="tt_allow_download" data-tooltip-place="top" style={{ cursor: 'help', display: 'flex' }}>
              <QuestIcon color="#9CA3AF" />
            </div>
          </Flex>
        </Flex>
      ) : (
        <CustomButton
          ref={ref}
          border={`1px solid ${primaryColor}`}
          pd={buttonPadding}
          action={toggleAllowDownload}
        >
          <Flex
            align="center"
            justify="left"
            gap="50px"
            style={{ position: 'relative' }}
          >
            <CheckBox
              color="#000000"
              active={isAllowed}
              action={toggleAllowDownload}
            />
            <Text clave="allow_download" size={textSize}>{t('allow_download')}</Text>
            <Flex
              style={{ position: 'absolute', left: isMobile ? 30 : 40, cursor: 'help' }}
              data-tooltip-id="tt_allow_download"
              data-tooltip-place="left"
              w="fit-content"
            >
              <QuestIcon />
            </Flex>
          </Flex>
        </CustomButton>
      )}
      <Tooltip id="tt_allow_download">
        <p style={{ width: '180px' }}>{t('tooltip_allow_download_text')}</p>
      </Tooltip>
    </Flex>
  );
});

export default AllowDownload;
